import * as React from "react";

export const FilterIcon = (props: any) => (
  <svg
    width={14}
    height={15}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M.125 0v1.465l5 6.25V15l3.75-2.813V7.715l5-6.25V0H.125Zm1.426 1.25h10.898L7.957 6.875H6.043L1.551 1.25Zm4.824 6.875h1.25v3.438l-1.25.937V8.125Z"
      fill="#424248"
    />
  </svg>
);
